import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import config from "../../config";

import "../../styles/popup.css"

import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

const AddEditRoleForm = ({ property, role, isEdit, onClose, onSubmit }) => {
    const roleOptions = ['admin', 'manager', 'tenant', 'owner', 'staff'];
    const [propertyRoles, setPropertyRoles] = useState([]);
    const [filteredAccounts, setFilteredAccounts] = useState([]);
    const [selectedRole, setSelectedRole] = useState("");
    const [selectedUser, setSelectedUser] = useState(null);
    const [error, setError] = useState(null);

    // Fetch all propertyRoles for this property
    useEffect(() => {
        const fetchPropertyRoles = async () => {
            try {
                const response = await axios.get(
                    `${config.API_URL}/v2/role/propertyRole/property/${property.property._id}`,
                    {headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}}
                );
                setPropertyRoles(response.data);
            } catch (err) {
                console.error("Error fetching property roles:", err);
                setError("Failed to load users for this property.");
            }
        };
        fetchPropertyRoles();

        // Prepopulate fields if editing
        if (isEdit && role) {
            setSelectedRole(role.propertyRole.role);
            setSelectedUser(role.propertyRole.account._id);
        }
    }, [isEdit, property.property._id, role]);

    // Filter accounts whenever selectedRole changes
    useEffect(() => {
        if (!selectedRole) {
            setFilteredAccounts([]);
            setSelectedUser(null);
            return;
        }
        const accountsForRole = propertyRoles
            .filter(pr => pr.role === selectedRole)
            .map(pr => pr.account);
        setFilteredAccounts(accountsForRole);
        setSelectedUser(null);
    }, [selectedRole, propertyRoles]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!selectedRole || !selectedUser) {
            setError("Both Role and User fields are required.");
            return;
        }

        console.log("🏠 property:", property);
        console.log("🧩 property._id:", property?._id);
        console.log("📋 propertyRoles:", propertyRoles);
        console.log("🧠 selectedRole:", selectedRole);
        console.log("👤 selectedUser:", selectedUser);

        // Find the propertyRole ID for this user & role
        const propertyRoleObj = propertyRoles.find(
            pr => pr.role === selectedRole && pr.account._id === selectedUser
        );

        console.log("✅ propertyRoleObj:", propertyRoleObj);

        if (!propertyRoleObj) {
            setError("Selected role and user combination is invalid.");
            console.log("❌ propertyRoleObj is undefined");
            return;
        }

        const roleData = {
            propertyRole: propertyRoleObj._id,
            unit: property._id
        };

        console.log("📤 Sending roleData:", roleData);

        try {
            if (isEdit) {
                roleData._id = role._id;
                const response = await axios.put(
                    `${config.API_URL}/v2/role/unitRole/${role._id}`,
                    roleData,
                    {headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}}
                );
                console.log("✅ PUT response:", response.data);
                onSubmit(response.data);
                toast.success("Role updated successfully!");
            } else {
                console.log("🆕 Creating new role");
                const response = await axios.post(
                    `${config.API_URL}/v2/role/unitRole`,
                    roleData,
                    {headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}}
                );
                console.log("✅ POST response:", response.data);
                onSubmit(response.data);
                toast.success("Role added successfully!");
            }
        } catch (err) {
            console.error("❌ Error saving role:", err);
            console.log("📦 Error response:", err.response?.data || err.message);
            setError("Failed to save role. Please try again.");
            toast.error("Failed to save role. Please try again.");
        }
    };


    return (
        <div className="popup-overlay">
            <div className="popup-content">
                <button className="close-popup" onClick={onClose}>
                    <i className="fas fa-times"></i>
                </button>
                <h2 className="text-2xl text-black">{isEdit ? "Edit Role" : "Add Role"}</h2>
                <form onSubmit={handleSubmit} className="role-form">
                    <Autocomplete
                        options={roleOptions}
                        getOptionLabel={(option) => option.charAt(0).toUpperCase() + option.slice(1)} // display capitalized
                        value={selectedRole ? selectedRole : null}
                        onChange={(event, newValue) => setSelectedRole(newValue ? newValue.toLowerCase() : "")} // store as lowercase
                        renderInput={(params) => <TextField {...params} label="Role" required />}
                        sx={{ marginBottom: "1rem" }}
                    />

                    <Autocomplete
                        options={filteredAccounts}
                        getOptionLabel={(option) => `${option.user.givenName} ${option.user.lastName} (${option.user.email})`}
                        value={filteredAccounts.find(acc => acc._id === selectedUser) || null}
                        onChange={(event, newValue) => setSelectedUser(newValue ? newValue._id : null)}
                        renderInput={(params) => <TextField {...params} label="User" required />}
                        sx={{ marginBottom: "1rem" }}
                    />

                    <button type="submit" className="button">
                        {isEdit ? "Update Role" : "Add Role"}
                    </button>
                </form>
                {error && <p className="error-text w-full font-poppins text-center text-[#FF0000] mt-2">{error}</p>}
            </div>
        </div>
    );
};

export default AddEditRoleForm;
